<widget-headless [config]="entitiesConfig"></widget-headless>
<nrwl-helpdialog></nrwl-helpdialog>
<div class="dashboard">
  <nrwl-navbar class="nav-bar" [dataSource]="navbarDataSource" *ngIf="!embedLayout"></nrwl-navbar>
  <mat-sidenav-container id="body">
    <mat-sidenav
      class="no-print"
      mode="side"
      [disableClose]="true"
      opened
      *ngIf="!hideOtherLayout && !embedLayout"
    >
      <fusion-ui-sidebar [dataSource]="perspectivesList" [wizardData]="wizards"></fusion-ui-sidebar>
    </mat-sidenav>

    <mat-sidenav-content class="dashboard-content">
      <div class="dashboard-slide">
        <router-outlet name="dashboard"></router-outlet>
      </div>
      <router-outlet name="wizard"></router-outlet>
      <router-outlet name="testSetup"></router-outlet>
    </mat-sidenav-content>
  </mat-sidenav-container>
</div>
<div id="arrow-content-bellow"></div>
